import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'; 
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('/');
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleLinkClick = (path) => {
    setActiveLink(path);
    if (isMenuOpen) setIsMenuOpen(false);
    window.scrollTo(0, 0); // Scroll to top when a link is clicked
  };

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className={`navbar navbar-expand-lg navbar-light navbar-glass sticky-top`} ref={menuRef}>
      <div className="container-fluid">
        <Link className="navbar-brand" to="/" onClick={() => handleLinkClick('/')}>
          <img src={logo} alt="Logo" className="navbar-logo" />
        </Link>

        {/* Hamburger Menu */}
        <div className="hamburger-mobile" onClick={toggleMenu}>
          <button className="hamburger">
            <span className="line line-1"></span>
            <span className="line line-2"></span>
            <span className="line line-3"></span>
          </button>
        </div>

        {/* Navbar Links */}
        <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link 
                className={`nav-link ${activeLink === '/' ? 'active' : ''}`} 
                to="/" 
                onClick={() => handleLinkClick('/')}
              >
                HOME
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${activeLink === '/about' ? 'active' : ''}`} 
                to="/about" 
                onClick={() => handleLinkClick('/about')}
              >
                ABOUT
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${activeLink === '/projects' ? 'active' : ''}`} 
                to="/projects" 
                onClick={() => handleLinkClick('/projects')}
              >
                PROJECTS
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${activeLink === '/locations' ? 'active' : ''}`} 
                to="/locations" 
                onClick={() => handleLinkClick('/locations')}
              >
                LOCATIONS
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link contact ${activeLink === '/contact' ? 'active' : ''}`} 
                to="/contact" 
                onClick={() => handleLinkClick('/contact')}
              >
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
